var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCard3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 43384"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 33",
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#C0DAFE"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "reject"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 43645"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M22.8242 20.7802C22.8242 21.0399 22.7313 21.291 22.5624 21.4881L19.9567 24.528C19.7241 24.7994 19.3367 24.8776 19.0171 24.7178C18.705 24.5618 18.5552 24.2 18.6655 23.869L19.561 21.1826L17.0572 21.1826C16.992 21.1826 16.9268 21.1767 16.8626 21.1651C16.2716 21.0576 15.8796 20.4913 15.987 19.9003L16.6792 16.0932C16.7733 15.576 17.2237 15.2 17.7494 15.2L21.7365 15.2C22.3372 15.2 22.8242 15.687 22.8242 16.2878L22.8242 20.7802Z",
    stroke: "#0049A6",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M25 15.7439L25 20.6388",
    stroke: "#0049A6",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 2336",
    cx: 20.2,
    cy: 20.0001,
    r: 10.45,
    stroke: "#0049A6",
    strokeWidth: 1.5
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard3);
export default __webpack_public_path__ + "static/media/Card3.eb944a67fa3f0e27587f2c02057e07b8.svg";
export { ForwardRef as ReactComponent };